import { Box, Typography } from "@bca/ui-library";

const SecondaryInfo: React.FunctionComponent<{
  items: string[];
}> = ({ items }) => {
  return (
    <Box
      as="ul"
      width="auto"
      height="auto"
      display="flex"
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      px="0"
      marginY={0}
      mx={5}
      my={{ mobile: 4, tablet: 5 }}
      css={`
        list-style-type: none;
      `}
    >
      {items.map(
        (item) =>
          Boolean(item) &&
          item !== "Unknown" && (
            <Box
              as="li"
              key={item}
              css={`
                text-transform: capitalize;
                & > p::after {
                  content: "|";
                  color: #dde1e5;
                  margin-left: 12px;
                  margin-right: 12px;
                }

                &:last-child > p::after {
                  display: none;
                }
              `}
            >
              <Typography variant="body-small" my="0" color="grey-blue">
                {item}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

export default SecondaryInfo;
